import { Link } from 'react-router-dom'
import { useUsoDaIa } from '../../../api/queries/usoDaIa'
import { AvisoDeErro, Esqueleto, EstadoVazio } from '../../../components/Estados'
import { IconeIndicador } from '../../../components/Icones'
import { TEXTOS } from '../../../lib/glossario'
import { TabelaDeUso } from './TabelaDeUso'

/**
 * Quanto a análise por IA consumiu, mês a mês — em UNIDADES DE USO.
 *
 * **O dinheiro mudou de tela, e não de existência.** Até a rc.4 esta tela dizia que o sistema não
 * converte unidades de uso em reais, porque não havia preço de modelo em lugar nenhum e porque um R$
 * aqui seria lido como custo do contrato com a contratada. A primeira razão caiu — o preço passou a
 * ser declarado, datado e com fonte. A segunda continua inteira, e por isso a conversão vive em
 * "Crédito de IA", com o preço e a procedência ao lado de cada valor.
 *
 * **Execução sem medição aparece à parte.** Parecer emitido antes de o sistema passar a medir não tem
 * unidades registradas; somá-lo como zero faria um mês caro parecer barato.
 *
 * @returns a tela do consumo
 */
export function PaginaUsoDaIa() {
  const t = TEXTOS.usoDaIa
  const { data: linhas, isPending, isError, error } = useUsoDaIa()

  return (
    <div className="space-y-5">
      <header>
        <h1 className="titulo-da-pagina">{t.titulo}</h1>
        <p className="mt-1 max-w-prose text-sm text-slate-600">{t.ajuda}</p>
      </header>

      {isPending && <Esqueleto linhas={4} />}
      {isError && <AvisoDeErro erro={error} />}

      {linhas && linhas.length === 0 && (
        <EstadoVazio icone={<IconeIndicador className="h-9 w-9" />} titulo={t.vazio.titulo} ajuda={t.vazio.ajuda} />
      )}

      {linhas && linhas.length > 0 && (
        <>
          <TabelaDeUso linhas={linhas} />
          <p className="max-w-prose text-xs text-slate-500">{t.origem.ajuda}</p>
          <p className="max-w-prose text-xs text-slate-500">
            {t.emTokens}{' '}
            <Link to="/admin/credito-da-ia" className="font-medium underline underline-offset-2">
              {TEXTOS.creditoDaIa.titulo}
            </Link>
            .
          </p>
        </>
      )}
    </div>
  )
}
